import { DailyPrize } from "./types";

export const DAILY_PRIZES: DailyPrize[] = [
  {
    prize: "£1,000 Cash",
    count: "4",
    // count: "15",
    imgId: "1000-cash",
  },
  {
    prize: "£250 Cash",
    count: "8",
    // count: "30",
    imgId: "250-cash",
  },
  {
    prize: "£100 Cash",
    count: "20",
    // count: "75",
    imgId: "100-cash",
  },
  {
    prize: "£50 Cash",
    count: "60",
    // count: "225",
    imgId: "50-cash",
  },
  {
    prize: "40% Discount on Next Order",
    count: "200",
    // count: "750",
    imgId: "40-discount",
  },
  {
    prize: "25% Discount on Next Order",
    count: "300",
    // count: "1,125",
    imgId: "25-discount",
  },
  {
    prize: "10% Discount on Next Order",
    count: "400",
    // count: "1,500",
    imgId: "10-discount",
  },
  {
    prize: "5 Audi A3 Sportback Tickets",
    count: "1,000",
    // count: "3,750",
    imgId: "5-audi-lifestyle",
  },
  {
    prize: "4 Super Car Tickets",
    count: "3,600",
    // count: "13,500",
    imgId: "4-super-car",
  },
  {
    prize: "3 Mini Cooper SE Tickets",
    count: "2,400",
    // count: "9,000",
    imgId: "3-mini-lifestyle",
  },
  {
    prize: "Keyboxes",
    count: "4,000",
    // count: "6,000",
    imgId: "keyboxes",
  },
  {
    prize: "£5 Game Credit",
    count: "800",
    // count: "3,000",
    imgId: "5-game-credit",
  },
  {
    prize: "£3 Game Credit",
    count: "1,600",
    // count: "6,000",
    imgId: "3-game-credit",
  },
  {
    prize: "£1 Game Credit",
    count: "1,600",
    // count: "6,000",
    imgId: "1-game-credit",
  },
  {
    prize: "£0.50 Game Credit",
    count: "8,008",
    // count: "30,030",
    imgId: "0-5-game-credit",
  },
];
